// extracted by mini-css-extract-plugin
export default {"container":"feed_container__XsKis"};